import React from 'react';
import autobind from 'autobind-decorator';
import {Col, Row} from 'react-bootstrap';

import {ConfirmationDialog} from './ConfirmationDialog';

import {config} from "../../Config";

export class ErrorDisplay extends React.Component {
    @autobind
    getTitle() {
        if(this.props.Error) {
            if(this.props.Error.Title) {
                return this.props.Error.Title;
            }
        }

        return "";
    }

    @autobind
    getCode() {
        if(this.props.Error) {
            if(this.props.Error.Code) {
                return this.props.Error.Code;
            }
        }

        //unknown error
        return 520;
    }

    @autobind
    getMessage() {
        if(this.props.Error) {
            if(this.props.Error.Message) {
                return this.props.Error.Message;
            }
        }

        return "An error has occurred.";
    }

    @autobind
    getStackTrace() {
        if(this.props.Error) {
            if(this.props.Error.StackTrace) {
                return this.props.Error.StackTrace;
            }
        }

        return null;
    }

    render() {
        const stack = this.getStackTrace();

        return <ConfirmationDialog
            Body={
                <React.Fragment>
                    <Row className="error-body no-gutters">
                        <Col xs={12}>
                            <h3>{this.getTitle()}</h3>
                            <hr />
                            {this.getMessage()}
                        </Col>
                    </Row>
                    {   /* Stacktrace should display on local */
                        stack && config.getEnvironment() === "local" ?
                            <Row className="error-stacktrace no-gutters">
                                <Col xs={12}>
                                    <h3>Stack Trace</h3>
                                    <hr />
                                    <code>{stack}</code>
                                </Col>
                            </Row>:
                            null
                    }
                </React.Fragment>
            }
            CancelButtonMessage={null}
            OnClose={null}
            ConfirmationButtonMessage="OK"
            Display={this.props.Display}
            OnConfirm={() => this.props.Close()}
        />;
    }
}


